import { useEffect } from "react";
import L from "leaflet";
import { GeodesicLine } from "leaflet.geodesic";

import { useMap } from "react-leaflet";

function RouteLine({ shipmentRoute, pacificCrossed }) {
  const map = useMap();

  useEffect(() => {
    const places = [];
    // lat/lon are reversed in geojson, so we need to swap them
    const lineSegmentsSwapped = shipmentRoute.coordinates.map(([lng, lat]) => [lat, lng]);

    // If the route crosses the antimeridian, we use a geodesic line
    if (pacificCrossed) {
      // remove any existing geodesic lines
      map.eachLayer((layer) => {
        if (layer.options && layer.options.color === "black") {
          map.removeLayer(layer);
        }
      });

      lineSegmentsSwapped.reverse().forEach((lineSegment) => {
        places.push(new L.LatLng(lineSegment[0], lineSegment[1] < 0 ? lineSegment[1] + 360 : lineSegment[1]));
      });
      const geodesic = new GeodesicLine(places, {
        color: "black",
        weight: 2,
        opacity: 0.75,
        dashArray: "5, 5",
        smoothFactor: 2,
        wrap: false,
      });
      geodesic.addTo(map);
    } else {
      const polyline = L.polyline(lineSegmentsSwapped, {
        color: "black",
        weight: 2,
        opacity: 0.75,
        dashArray: "5, 5",
        smoothFactor: 2,
      });
      polyline.addTo(map);
    }
  }, [shipmentRoute, pacificCrossed]);
}

export default RouteLine;
